import React from 'react';
import { Form, Label } from 'semantic-ui-react';

const renderInput = ({
  input,
  label,
  type,
  customClass,
  errorMessage,
  invalidErrorMessage,
  placeholder,
  required,
  min,
  onClick,
  meta: { touched, error },
  allowNameCharsOnly,
  alphaNumericOnly,
}) => {
  let isComposing = false;
  const showError = errorMessage && touched && error;

  const handleCompositionStart = () => {
    isComposing = true;
  };

  const handleCompositionEnd = (e) => {
    isComposing = false;
    handleChange(e, true);
  };

  const handleChange = (e, force = false) => {
    const { value } = e.target;
    let newValue = value;

    if (!allowNameCharsOnly && !alphaNumericOnly) {
      input.onChange(value);
      return;
    }

    if (isComposing && !force) {
      input.onChange(value);
      return;
    }

    if (allowNameCharsOnly) {
      // first/last name
      newValue = value
        .replace(/[^A-Za-zÀ-ÖØ-öø-ÿĀ-žḀ-ỿ'\s-]/g, '')
        .replace(/\s{2,}/g, ' ')
        .trimStart();
    } else if (alphaNumericOnly) {
      newValue = value.replace(/[^A-Za-z0-9]/g, '');
    }

    input.onChange(newValue);
  };

  return (
    <Form.Field className={ `${customClass || ''} ${showError ? 'error' : ''} ${required ? 'required' : ''}` }>
      <label>{ label }</label>
      <input
        { ...input }
        placeholder={ placeholder }
        type={ type }
        min={ min || '' }
        onClick={ onClick || function () {} }
        onChange={ handleChange }
        onCompositionStart={ handleCompositionStart }
        onCompositionEnd={ handleCompositionEnd }
      />
      {showError && <Label basic pointing>{ error.invalid ? invalidErrorMessage : errorMessage }</Label>}
    </Form.Field>
  );
};

export default renderInput;
